import type { AvailabilityCheckControlOptions } from '../../../utils/types/availabilityCheck'
import type { BLOCK_TYPE } from '../enums'
import type { ReferenceId } from '../ids'
import type { BlockReference } from '../references'

import type { BlockBaseSettings, IBlock } from './base'

export enum AVAILABILITY_CHECK_FUNCTIONS {
  /** Matches against a file to evaluate a jump to step action */
  AVAILABILITY_CHECK = 'availabilityCheck',
  /** Matches against products availability part of associated product blocks */
  PRODUCT_AVAILABILITY_CHECK = 'productAvailabilityCheck'
}

/**
 * References to Products block.
 * This is used to extract availability information for products for availability checks.
 */
export interface AvailabilityProductBlockReference extends BlockReference {
  meaning: 'products'
}

export interface AvailabilityCheckBlock extends IBlock {
  type: BLOCK_TYPE.AVAILABILITY_CHECK
  settings: BlockBaseSettings & AvailabilityCheckControlOptions
  /**
   * References multiple product blocks (1-to-N)
   */
  references: Record<ReferenceId, AvailabilityProductBlockReference>
}

export type AvailabilityBlockValue = {
  zipCode?: string | null
  city?: string | null
  streetName?: string | null
  streetNumber?: string | null
  countryCode?: string | null
}
